
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiProvider, useAccount } from 'wagmi'
import { config } from './config'

import { Account } from './account'
import { WalletOptions } from './walletOptions'
import { SendTransaction } from './SendTransaction'

const queryClient = new QueryClient()

function ConnectWallet() {
    const { isConnected } = useAccount()
    if (isConnected) return <Account />
    return <WalletOptions />
}

function WalletApp() {
    return (
        <WagmiProvider config={config}>
            <QueryClientProvider client={queryClient}>
                <ConnectWallet />
            </QueryClientProvider>
        </WagmiProvider>
    )
}

export default WalletApp